const CTASection = () => {
  return (
    <section className="bg-blush py-24 px-6">
      <div className="max-w-4xl mx-auto text-center">
        <h2 className="text-5xl font-semibold text-charcoal font-serif mb-6">
          Ready for Your Transformation?
        </h2>
        <p className="text-lg text-gray-600 font-sans mb-10">
          Join our community of <em className="font-medium">confident</em> clients
        </p>
        <a
          href="/contact"
          className="inline-flex items-center gap-3 px-10 py-4 bg-sage text-white font-sans text-base font-medium rounded-full hover:bg-sage-dark transition-all hover:transform hover:scale-105 shadow-md whitespace-nowrap cursor-pointer"
        >
          Get in Touch
          <i className="ri-arrow-right-line text-xl"></i>
        </a>
      </div>
    </section>
  );
};

export default CTASection;